import { Divider } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { IHarvestFinishBody } from '@shared/interfaces/lib/contractInterfaces';
import { MetrcFacilitySubCollections } from '@shared/interfaces/lib/firebaseConstants';
import { IHarvest } from '@shared/interfaces/lib/interfaces';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { postHarvestFinish } from '../../../api';
import { selectUser, setShowPlantDetails } from '../../../redux/appSlice';
import { PlantDetailPages } from '../../../redux/interfaces';
import { useDetailsStyles } from '../details';

interface IProps {
    harvest: IHarvest;
    facilityId: string;
    undo: boolean;
}

const HarvestFinish: React.FC<IProps> = ( { harvest, undo, facilityId } ) => {
    const dispatch = useDispatch();
    const classes = useDetailsStyles();
    const user = useSelector( selectUser );
    const [loading, setLoading] = useState( false );

    if ( !harvest ) {
        return null;
    }

    const handleDone = () => {
        dispatch( setShowPlantDetails( {
            key: {
                collection: MetrcFacilitySubCollections.metrcHarvests,
                id: harvest.id,
            },
            page: PlantDetailPages.harvestDetails,
        } ) );
    };

    const handleSubmit = () => {
        if ( !user ) {
            return;
        }

        setLoading( true );

        const body: IHarvestFinishBody = {
            facilityId,
            id: harvest.metrc.Id,
            date: DateTime.local().toISODate(),
            undo,
        }
        postHarvestFinish( user.token, body )
            .then( () => {
                handleDone();
            } )
            .finally( () => {
                setLoading( false );
            } );
    };

    return (
        <>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start" color="inherit" onClick={() => dispatch( setShowPlantDetails( undefined ) )}
                        aria-label="close"
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Finish Harvest {harvest.metrc.Name}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.content}>
                {loading ? (
                    <CircularProgress size={24}/>
                ) : (
                    <>
                        <Typography variant="body1">
                            This harvest will no longer be able to be modified or cut from.
                            The remaining weight will be recorded as moisture.
                        </Typography>
                        <Typography variant="body1">
                            <b>Remaining Weight: {harvest.metrc.CurrentWeight}</b>
                        </Typography>
                        <Divider style={{ marginBottom: 10 }}/>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleDone}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                        >
                            Confirm Finish
                        </Button>
                    </>
                )}
            </div>
        </>
    )
};

export default HarvestFinish;